import type { ViolationSeverity } from '../types';

/**
 * Severity of a broken rule as the screens use it.
 *
 * The backend reports it in lower case ("high", "medium", "low"), so it is
 * compared without regard to case. Anything else reads as "Low", as it did
 * before and as in the lifecycle's ApprovalWarningsDialog. The backend always
 * sends one of the three (aspicerules.Severity folds the rule set's "Critical"
 * into "high" and applies its own "medium" default to a rule without one), so
 * this only covers a value that is missing altogether.
 */
export function normalizeSeverity(
  severity: string | undefined,
): ViolationSeverity {
  switch (severity?.toLowerCase()) {
    case 'high':
      return 'High';
    case 'medium':
      return 'Medium';
    default:
      return 'Low';
  }
}

/**
 * Class for a severity chip, taken from the shared styles. HIGH red, MEDIUM
 * orange, LOW blue — the colours of the lifecycle's ApprovalWarningsDialog,
 * which the Requirement Doctor also shows (for the gate's warnings), so a rule
 * reads the same colour in both of its dialogs.
 */
export function severityChipClass(
  severity: ViolationSeverity,
  shared: { chipError: string; chipWarning: string; chipInfo: string },
): string {
  if (severity === 'High') return shared.chipError;
  if (severity === 'Medium') return shared.chipWarning;
  return shared.chipInfo;
}
